"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickTile = void 0;
const react_redux_1 = require("react-redux");
const ui_1 = require("~/store/game/ui");
const board_1 = require("@creature-chess/board");
const resolvePiecePlacement_1 = require("../resolvePiecePlacement");
const useOnClickTile = (board, bench, { canClickBoard = true } = {}) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const store = (0, react_redux_1.useStore)();
    return ({ location }) => {
        if (location.locationType === "board" && !canClickBoard) {
            return;
        }
        const selectedPieceId = store.getState().game.ui.selectedPieceId;
        if (!selectedPieceId) {
            return;
        }
        const toY = location.locationType === "board" ? location.y : 0;
        const target = {
            type: location.locationType,
            location: (0, board_1.packPosition)(location.x, toY),
        };
        const result = (0, resolvePiecePlacement_1.resolvePiecePlacement)(selectedPieceId, target, board, bench);
        // Clicks deliberately don't swap - drag is the swap gesture.
        if (result.kind !== "drop") {
            return;
        }
        dispatch(result.action);
        dispatch((0, ui_1.clearSelectedPiece)());
    };
};
exports.useOnClickTile = useOnClickTile;
